import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getEmployee,
  updateEmployee,
  updateEmployeeSignature,
} from "../../api/server";
import { withNotifications } from "../notifications/notificationsSlice";

const initialState = {
  error: null,
  activeEmployee: {},
};

export const loadRecord = createAsyncThunk(
  "employee/loadEmployee",
  async (params) => {
    return getEmployee(params).then(({ error, data }) => {
      if (error) {
        // throw new NotificationError("Load employee", error);
      }
      return data;
    });
  }
);

export const commitChanges = createAsyncThunk(
  "employee/update",
  withNotifications(
    async (params, thunkAPI) => {
      const { activeEmployee } = thunkAPI.getState().employee;
      const { id } = activeEmployee;
      const branchNumber =
        activeEmployee.active_branches &&
        activeEmployee.active_branches[0] &&
        activeEmployee.active_branches[0].id;
      const scopePrefix = `branches/${branchNumber}/`;
      return updateEmployee({
        employee: { id, ...params },
        scopePrefix,
      });
    },
    "save_employee",
    "save_employee_success",
    "save_employee_error"
  )
);

export const updateSignature = createAsyncThunk(
  "employee/update",
  withNotifications(
    async (params, thunkAPI) => {
      const { activeEmployee } = thunkAPI.getState().employee;
      const { id } = activeEmployee;
      const branchNumber =
        activeEmployee.active_branches &&
        activeEmployee.active_branches[0] &&
        activeEmployee.active_branches[0].id;
      const scopePrefix = `branches/${branchNumber}/`;
      return updateEmployeeSignature({
        employeeId: id,
        signature: params.signature,
        scopePrefix,
      });
    },
    "save_signature",
    "save_signature_success",
    "save_signature_error"
  )
);

const employeeSlice = createSlice({
  name: "employee",
  initialState: initialState,
  reducers: {
    setActiveEmployee(state, action) {
      const { record } = action.payload;
      state.activeEmployee = record;
    },

    reset(state) {
      state.error = null;
      state.activeEmployee = {};
    },
  },
  extraReducers: {
    [loadRecord.fulfilled]: (state, action) => {
      state.activeEmployee = action.payload;
    },
    [updateSignature.fulfilled]: (state, action) => {
      state.error = action.error;
    },
  },
});

export const { setActiveEmployee, reset } = employeeSlice.actions;

export const isEmployeeActive = (record) => {
  return record && record.status !== 2;
};

export const getEmployeeStatus = (record) => {
  let status = "success";
  switch (record.status) {
    case 1:
      status = "success";
      break;

    case 2:
      status = "error";
      break;

    case 3:
      status = "default";
      break;

    default:
      break;
  }

  return status;
};

export default employeeSlice.reducer;
